import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getYcLogoFile} from '../../../../../utils/entity/file';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, membership, payment, program} = contexts;

  const data: EventData = {};

  if (payment) {
    if (payment.type === 'program') {
      data.avatar = program?.avatar;
      data.avatarPlaceholder = program?.title;

      const isExternal =
        course &&
        course.edition &&
        course.edition.payment_plan &&
        course.edition.payment_plan.processing === 'external';

      const titleKey = isExternal ? 'external' : 'internal';

      data.title =
        /**
         * @i18n_parser
         *
         * t('notifications:payment_upcoming.program.internal.title')
         * t('notifications:payment_upcoming.program.external.title')
         */
        i18n.t(`notifications:payment_upcoming.program.${titleKey}.title`, {
          courseTitle: program?.title,
          price: getPriceString({
            currency: Currency[payment.currency],
            price: payment.amount,
          }),
        });
    } else {
      data.avatar = getYcLogoFile(180);
      data.avatarPlaceholder = 'Your Coach';

      data.title =
        /**
         * @i18n_parser
         *
         * t('notifications:payment_upcoming.refund.title')
         * t('notifications:payment_upcoming.subscription.title')
         */
        i18n.t(`notifications:payment_upcoming.${payment.type}.title`, {
          price: getPriceString({
            currency: Currency[payment.currency],
            price: payment.amount,
          }),
          userName: membership?.user_name,
        });
    }
  }

  return data;
};
